// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1s1HY","errors":"Errors_errors__wNX1i"};